export default {
	getAdvertisements: state => state.advertisements
}
